import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

const VcfButton = ({ file, fileName }) => {
  console.info(file);
  const handleDownload = async () => {
    const response = await fetch(file);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "contact.vcf"; // You can customize the filename here
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url); // Clean up the URL object
  };

  return (
    <button onClick={handleDownload} className="icon-button">
      <FontAwesomeIcon icon={faUserPlus} />
    </button>
  );
};

export default VcfButton;
